import React, { useCallback, useEffect, useState } from 'react';
import b_ from 'b_';
import './styles.scss';
import {Table, Typography} from 'antd';
import PrintPrice from '../../../Components/Prints/PrintPrice';
import { engineStatusExpensesFetch } from '../../../Reducers/engineStatus';
import useTable from '../../../Utils/useTable';
import Filters from '../Filters';
import SubscrFilters from '../TableSubscr/SubscrFilters';
import { useDispatch } from 'react-redux';
import { getCurrentDates } from '../../../Utils/dates';
import { EuroCircleOutlined } from '@ant-design/icons';

const b = b_.lock('StatusTable');

function TableExpenses() {

  const dispatch = useDispatch();

  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [curFilters, setCurFilters] = useState({ dates: getCurrentDates() });

  useEffect(() => {
    setLoading(true)
    dispatch(engineStatusExpensesFetch(curFilters.dates))
    .then((res) => {
      setList(res)
    })
    .catch((e) => {
      console.log(`Error fetching: ${e}`)
    })
    .finally(() => {
      setLoading(false)
    })
}, [curFilters, dispatch]);


  const rowClassName = (record) => {
    if (record.name === 'TOTAL') {
      return 'highlighted-row';
    }
    return '';
  };

  const GetColumns = useCallback(() => {
    return [
        { 
          dataIndex: "name",
          title: "Group",
          align: "center",
          width: 100,
        },
       { 
          title: "Purchased",
          align: "center",
          dataIndex: "spent",
          render: (spent) => (
                      <div className={b('col')}>
                        <PrintPrice value={spent} currency="€" />
                      </div>
                    )},
        { 
          title: "Redeemed",
          align: "center",
          dataIndex: "redeemed",
          render: (red) => (
                      <div className={b('col')}>
                        <PrintPrice value={red} currency="€" />
                      </div>
                    )},
    ]
  }, [list])

  const [columns, setColumns] = useState(GetColumns());
  const [updatedList, setUpdatedList] = useState([]);

  useEffect(() => {
    setColumns(GetColumns())
}, [list, GetColumns])

useEffect(() => {
    const updatedList = 
      list.map((item) => {
        if (item.name !== 'ALL' && item.isCurrency) {
          const updatedItem = { ...item };
          updatedItem.spent = item.spent;
          updatedItem.redeemed = item.redeemed;
          return updatedItem;
        }
        return item;
      })
    
    setColumns(GetColumns());
    setUpdatedList(updatedList)
      
    const updatedSum = calculateSum(updatedList);
    setUpdatedList((prev) => [...prev, updatedSum]);
}, [list]);

const calculateSum = useCallback((listToUpdate) => {
  const sum = {
    name: 'TOTAL',
    spent: 0,
    redeemed: 0,
  };

  listToUpdate.forEach(item => {
    if (item.name !== 'ALL') {
      sum.spent += item.spent;
      sum.redeemed += item.redeemed;
    }
  });

  return sum;
}, [list]);

const filteredList = updatedList.filter(item => item.name !== 'ALL');


  return (
    <div className='ExpJobsTable'>
    <Typography.Title level={4}><EuroCircleOutlined /> Expenditures</Typography.Title>
    <Filters curFilters={curFilters} setCurFilters={setCurFilters} />
  <Table 
        rowKey="name"
        bordered
        className={b('table')}
        dataSource={filteredList}
        pagination={false}
        columns={columns}
        loading={loading}
        size="small"
        scroll={{ x: "max-content" }}
        rowClassName={rowClassName}
  />
  </div>
  );
}

export default TableExpenses;
